/** Avoid splitting surrogate pairs when inserting at a stale UTF-16 cursor index. */

export function clampUtf16InsertIndex(value, index) {
    const text = typeof value === 'string' ? value : '';
    const len = text.length;
    let i = Math.max(0, Math.min(Number(index) || 0, len));

    if (i <= 0 || i >= len) {
        return i;
    }

    const code = text.charCodeAt(i);
    const prev = text.charCodeAt(i - 1);

    if (prev >= 0xd800 && prev <= 0xdbff && code >= 0xdc00 && code <= 0xdfff) {
        return i + 1;
    }

    if (code >= 0xdc00 && code <= 0xdfff) {
        return i - 1;
    }

    return i;
}

export function insertStringAtUtf16Index(value, index, insert) {
    const current = typeof value === 'string' ? value : '';
    const insertion = typeof insert === 'string' ? insert : '';
    const safeIndex = clampUtf16InsertIndex(current, index);

    return current.slice(0, safeIndex) + insertion + current.slice(safeIndex);
}
